import React, { useState } from 'react'
import Sidebar from '@/shared/components/Sidebar'
import Header from '@/shared/components/Header'
import type { UserProfile } from '@/services/api'

interface AuthenticatedLayoutProps {
  activeRoute?: string
  children: React.ReactNode
  containerClassName?: string
  mainClassName?: string
  user?: UserProfile | null
  onLogout?: () => void
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  activeRoute = 'dashboard',
  children,
  containerClassName = 'w-full max-w-none px-4 sm:px-6 lg:px-8 py-6',
  mainClassName = 'bg-gray-50',
  user,
  onLogout
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true)

  return (
    <div className="flex min-h-screen bg-white">
      {/* Sidebar */}
      <Sidebar 
        activeRoute={activeRoute} 
        user={user}
        onCollapsedChange={setIsSidebarCollapsed}
      />
      
      {/* Main Content Area */}
      <div 
        className={`flex-1 flex flex-col overflow-hidden min-w-0 bg-white transition-all duration-300 ${
          isSidebarCollapsed ? 'ml-20' : 'ml-80'
        }`}
      >
        {/* Header */}
        <Header user={user} onLogout={onLogout} />
        
        {/* Main Content */}
        <main className={`flex-1 overflow-y-auto ${mainClassName}`}>
          <div className={`w-full ${containerClassName}`}>
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default AuthenticatedLayout
